import {vnTemplate} from "../../../../valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class imagePickerGalleryView_template extends vnTemplate {

    protected parent: any;

    protected getTemplateHtml(): string {

        return `
             <div class="w-img-picker-view" data-bind="css: { 'is-visible': isShown }">
                    
                <div class="img-picker-view ">
                    <div class="view-header">
                        <strong data-bind="text: name() + ' (' + images().length + ' images)'"></strong>             
                        <button type="button" class="close-btn icon i-close" data-bind="event: { click: onClickCancel }"></button>
                    </div>
                    <div class="view-body">
                        <div class="w-view-img-list">
                            <ul class="view-img-list" data-bind="foreach: images">
                                   
                                <li class="view-img-item" data-bind="attr: {id: id }">
                                    <div class="dropdown">
                                        <!--<button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>-->
                                        <div class="dropdown-list">

                                             <button class="btn-icon icon i-download" title="Download" type="button" data-bind="event: { click: $parent.onClickDownloadImage }"><span>Download</span></button>
                                             <button class="btn-icon icon i-full-size" title="View Original"  type="button" data-bind="event: { click: $parent.onClickViewOriginalImage }"><span>View Original</span></button>
                                             <button class="btn-icon icon i-ins-ind"  title="Insert Indivillualy" type="button"data-bind="event: { click: $parent.onClickInsertImage.bind($data, '') }" ><span>Insert Indivillualy</span></button>
<!--                                             <button class="btn-icon icon i-ins-gallery" title="Insert as Gallery" type="button" data-bind="event: { click: $parent.onClickInsertImage.bind($data, '') }"><span>Insert as Gallery</span></button>-->
                                             <button class="btn-icon icon i-ins-grid" title="Insert as Grid" type="button"  data-bind="event: { click: $parent.onClickInsertImage.bind($data, 'grid_view') }"><span>Insert as Grid</span></button>
                                             <button class="btn-icon icon i-remove-to-gallery" title="Remove from Group" type="button" data-bind="event: { click: $parent.onClickRemoveImage }"><span>Remove from Group</span></button>
                                             <button class="btn-icon icon i-edit" title="Edit" type="button" data-bind="event: { click: $parent.onClickEditImage }"><span>Edit</span></button>
                                             
                                        </div>
                                    </div>
                                    <div class="view-img-container">
                                        <img data-bind="attr: {src: url, alt: altText }">  
                                    </div> 
                                </li>
                            </ul>
                        </div>
                         <div class="view-footer">
                           <div></div>
                           <div>
                                <div class="insert-dropdown">
                                    <button class="btn-icon insert-dropdown-toggle i-dropdown-simple icon i-ins" type="button"><span>Insert</span></button>
                                    <div class="insert-dropdown-list">
                                        <button class="btn-icon icon i-ins-ind" data-bind="event: { click: onClickInsertImagesIndividually}" type="button" title="Insert Individually" type="button"><span>Individually</span></button>
                                        <button class="btn-icon icon i-ins-gallery" data-bind="event: { click: onClickInsert.bind($parent, '') }, css: { 'is-disable': images().length == 1 }" type="button" title="Insert Gallery" type="button"><span>Insert As Gallery</span></button>
                                        <button class="btn-icon icon i-ins-grid" data-bind="event: { click: onClickInsert.bind($parent, $parent.isInsertAsGrid()) }" title="Insert as Grid" type="button"><span>Insert as Grid</span></button>
                                    </div>
                                </div>
                                <!--
                                <div class="btn-icon-joint">
                                    <button class="btn-icon icon i-insert" type="button" title="Quick insert" data-bind="event: { click: onClickInsert.bind($parent, '') }"><span>Quick Insert</span></button>
                                    <button class="btn-icon icon i-insert-grid" type="button" title="Insert as Grid" data-bind="event: { click: onClickInsert.bind($parent, $parent.isInsertAsGrid()) }"><span>Insert as Grid</span></button>
                                </div>
                                -->
                                <button class="btn-icon icon i-edit" type="button" data-bind="event: { click: onClickEdit }"><span>Edit</span></button>
                           </div>
                            <!--<button class="btn" type="button">Upload Image</button>-->
                            <!--<button class="btn" type="button">Delete</button>-->
                        </div>
                        <div class="w-view-info">
                            <div class="view-info">
                                <strong class="title">Description</strong>
                                <!-- ko if: description -->
                                <p data-bind="html: description"></p>  
                                <!-- /ko -->   
                                <!-- ko ifnot: description -->
                                <p>None</p>  
                                <!-- /ko --> 
                                <!-- ko if: permissions()['article_edit_embargo'].write -->
                                <strong class="title">Under Embargo</strong>
                                <p data-bind="text: (isUnderEmbargo() ? 'Yes' : 'No')"></p>
                                <!-- /ko -->   
                               
                              
                            </div>
                        </div>     
                    </div>
                   
                </div> 
                
            </div>
            `;
    }

    public getViewModelForRequest(){

        return {
             filters      : {
                keywords: this.getTemplateViewModel().filterSimple.filterKeyword,
            },
        }
    }



    protected initPartial(): void {

    }

    protected getTemplateName(): string {
        return "imagePickerGalleryView-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    protected buildViewModel(): any {

        //create observable array refresh function
        ko.observableArray.fn.refresh = function (item, index) {
            if (index==null) index = this['indexOf'](item);
            if (index >= 0) {
                this.splice(index, 1, ko.utils.extend({}, item)) // create new item
            }
        }

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return {
            isShown: ko.observable(false),
            name: ko.observable(null),
            idGallery: ko.observable(null),
            description: ko.observable(null),
            creditText: ko.observable(null),
            images: ko.observableArray([]),
            isImageOptimizable:  ko.observable(false),
            isUnderEmbargo: ko.observable(false),
            permissions: ko.observableArray(this.initPermissions(['article_edit_embargo'])),
            onClickCancel: function(data, event){ huit_neuf_this.onClickCancel();},
            onClickInsert: function(param, data, event){ huit_neuf_this.onClickInsert(param, data);},
            onClickEdit: function(data, event){ huit_neuf_this.onClickEdit();},
            onClickEditImage: function(data, event){ huit_neuf_this.onClickEditImage(data);},
            onClickInsertImage: function(param, data, event){ huit_neuf_this.onClickInsertImage(param, data);},
            onClickDownloadImage: function(data, event){ huit_neuf_this.onClickDownloadImage(data);},
            onClickViewOriginalImage: function(data, event){ huit_neuf_this.onClickViewOriginalImage(data);},
            onClickRemoveImage: function(data, event){ huit_neuf_this.onClickRemoveImage(data);},
            onClickInsertImagesIndividually: function(data, event){ huit_neuf_this.onClickInsertImagesIndividually();},
        };
    }

    public setParent(parent){

        this.parent = parent;
    }

    protected onClickCancel(){

        this.hide();
    }


    public setIsImageOptimizable(isImageOptimizable: boolean): void {
        this.getTemplateViewModel().isImageOptimizable(isImageOptimizable);
    }

    public isImageOptimizable(): boolean {
        return this.getTemplateViewModel().isImageOptimizable();
    }

    protected onClickEdit(){

        this.parent.editGallery(this.getGallery());
        //this.hide();
    }

    protected onClickEditImage(data){

        this.parent.editImage(data);
        //this.hide();
    }

    protected onClickInsertImage(param, data){
        this.parent.insertImage(data, param);
        this.hide();
    }

    protected onClickDownloadImage(image){
        this.parent.downloadFile(image.url,image.name);
    }

    protected onClickViewOriginalImage(image){
        this.parent.getFile(image.url, image.name, false);
    }

    protected onClickInsert(param, data){

        this.parent.insertGallery(this.getGallery(), param);
        this.hide();
    }
    
    protected onClickRemoveImage(imageToDelete){
        let gallery_images = this.getTemplateViewModel().images()
        this.parent.setMustInsertInGallery(false)

        if(gallery_images.length > 1){
            gallery_images.splice(gallery_images.findIndex(i => i.id === imageToDelete.id),1);
            this.getTemplateViewModel().images([])
            this.getTemplateViewModel().images(gallery_images)
            this.parent.saveGallery(this.getGallery(), imageToDelete, '');
        }
    }

    public setGallery(gallery){

        if(gallery){
            this.getTemplateViewModel().idGallery(gallery.id);
            this.getTemplateViewModel().name(gallery.name);
            this.getTemplateViewModel().description(gallery.description);
            this.getTemplateViewModel().images([]);
            this.getTemplateViewModel().isUnderEmbargo(gallery.isUnderEmbargo);
            this.getTemplateViewModel().images(gallery.images);
            this.getTemplateViewModel().creditText(gallery.creditText);
        }

    }
    
    public refreshImage(image){

        let images = this.getTemplateViewModel().images();
        let index = images.findIndex(i => i.id == image.id);
        if(~index){
            images[index] = image;
        }
        this.getTemplateViewModel().images(images);
    }

    protected getGallery(){

        let viewModel = this.getTemplateViewModel();

        let gallery = { id: viewModel.idGallery(),
            name: viewModel.name() ,
            description: viewModel.description(),
            images: viewModel.images() };

        return gallery;
    }

    public onClickInsertImagesIndividually(){

        let gallery =  this.getGallery();
        let images = gallery.images;

        console.log(images)

        for (let image of images){

            image.isMobileOptimized = (this.isImageOptimizable() && image.isLandscape && !image.isWaterMark);
            this.parent.insertImage(image, '');
        }

        this.hide();
    }


    public show(){

        this.getTemplateViewModel().isShown(true);
    }

    public hide(){

        this.getTemplateViewModel().isShown(false);
    }
    
    public getIsShown(){

        return this.getTemplateViewModel().isShown();
    }

    public setPermissions(permissions){

        this.getTemplateViewModel().permissions(permissions);
    }

}



// WEBPACK FOOTER //
// ./vendor/valnet/valnet_imagePicker/js/components/templates/imagePickerGalleryView_template.ts